// general domain - function for all places to update state as callback from service manager
export const updateStateApi = (setError, setData) => (response) => {
    if (response.error) {
        setError(response.error);
    } else {
        setData(response.data);
    }
};
